module.exports = __webpack_public_path__ + "static/img/4.399a843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/add/4.png
// module id = LQnf
// module chunks = 1